import type { SVGProps } from "react";

/**
 * video-clip, film, movie
 * @category Photography & Video
 */
export default function IconVideoClip(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M3.75 12H7.75M3.75 12V7.875M3.75 12V16.125M7.75 12H16.25M7.75 12V16.125M7.75 12V7.875M16.25 12H20.25M16.25 12V16.5833M16.25 12V7.875M20.25 12V7.875M20.25 12V16.5833M16.25 20.25H18.25C19.3546 20.25 20.25 19.3546 20.25 18.25V16.5833M16.25 20.25V16.5833M16.25 20.25H7.75M16.25 3.75H18.25C19.3546 3.75 20.25 4.64543 20.25 5.75V7.875M16.25 3.75V7.875M16.25 3.75H7.75M16.25 7.875H20.25M16.25 16.5833H20.25M7.75 20.25H5.75C4.64543 20.25 3.75 19.3546 3.75 18.25V16.125M7.75 20.25V16.125M7.75 3.75H5.75C4.64543 3.75 3.75 4.64543 3.75 5.75V7.875M7.75 3.75V7.875M3.75 7.875H7.75M3.75 16.125H7.75'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='square'
        strokeLinejoin='round'
      />
    </svg>
  );
}
